(function () {
  function submitCheckout(btn) {
    var form = btn.closest('form');
    if (!form) return;

    var idInput = form.querySelector('.product-variant-id');
    if (!idInput || !idInput.value) {
      alert('Bitte w\u00e4hle eine Variante aus.');
      return;
    }

    var btnText = btn.querySelector('[data-buy-now-text]');
    var originalText = btnText ? btnText.textContent : '';
    var spinner = btn.querySelector('.loading-overlay__spinner');

    btn.disabled = true;
    if (btnText) btnText.textContent = 'Einen Moment\u2026';
    if (spinner) spinner.classList.remove('hidden');

    var wasDisabled = idInput.disabled;
    idInput.disabled = false;
    var formData = new FormData(form);
    idInput.disabled = wasDisabled;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) {
        if (res.ok) {
          window.location.href = '/checkout';
          return null;
        }
        return res.json().then(function (err) { throw err; });
      })
      .catch(function (err) {
        console.error('Buy now error:', err);
        alert((err && err.description) || 'Fehler beim Hinzuf\u00fcgen zum Warenkorb. Bitte versuche es erneut.');
        btn.disabled = false;
        if (btnText) btnText.textContent = originalText;
        if (spinner) spinner.classList.add('hidden');
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-buy-now]');
    if (!btn) return;
    event.preventDefault();
    submitCheckout(btn);
  });
})();
